import { translateError } from '@components/core-ui/ErrorMessage/helpers/translateError';
import { validatePassword } from '@helpers/validatePassword';
import { useRef, useState } from 'react';

const getPasswordErrorKey = (password: string) => (password ? validatePassword(password, '') : '');

const getConfirmationErrorKey = (password: string, confirmation: string) =>
  password !== confirmation ? 'err.password.not_matches' : '';

export const usePasswordFieldErrors = (password: string, confirmation: string) => {
  const passwordRef = useRef<HTMLInputElement | null>(null);
  const confirmationRef = useRef<HTMLInputElement | null>(null);
  const [isPasswordChecked, setIsPasswordChecked] = useState(false);
  const [isConfirmationChecked, setIsConfirmationChecked] = useState(false);

  const passwordErrorKey = isPasswordChecked ? getPasswordErrorKey(password) : '';
  const confirmationErrorKey = isConfirmationChecked ? getConfirmationErrorKey(password, confirmation) : '';

  const onPasswordBlur = () => {
    if (password) {
      setIsPasswordChecked(true);
    }
  };

  const onConfirmationBlur = () => {
    if (confirmation) {
      setIsConfirmationChecked(true);
    }
  };

  const validatePasswordFields = () => {
    setIsPasswordChecked(true);
    setIsConfirmationChecked(true);
    if (getPasswordErrorKey(password)) {
      passwordRef.current?.focus();
      return false;
    }
    if (getConfirmationErrorKey(password, confirmation)) {
      confirmationRef.current?.focus();
      return false;
    }
    return true;
  };

  return {
    passwordRef,
    confirmationRef,
    passwordError: translateError(passwordErrorKey),
    confirmationError: translateError(confirmationErrorKey),
    onPasswordBlur,
    onConfirmationBlur,
    validatePasswordFields,
  };
};
